import { translate } from "./translations";

export const BYE_COMPETITOR_ID = 0;

export const FIGHT_FINISH_TYPE_DOUBLE_DQ = "doubleDisqualification";

export const ROUND_REGULAR = 0;
export const ROUND_OVERTIME_WITH_LIMIT = -1;
export const ROUND_OVERTIME_NO_LIMIT = -2;
export const ROUND_NOT_AVAILABLE = -3;
export const ROUND_SECOND_OVERTIME_WITH_LIMIT = -4;

export const ROLE_TECH_ACCOUNT = "techAccount";

export const COUNTRY_NOT_AVAILABLE = "N/A";

export const KEY_ENTER = "enter";
export const KEY_TAB = "tab";
export const KEY_TAB_SHIFT = "tabShift";

export const EVENT_USER_ROLE_FULL_ORGANIZER = "1";
export const EVENT_USER_ROLE_TECHNICIAN = "2";
export const EVENT_USER_ROLE_STAFF = "4";

export const BUNDLE_REFEREE = "referee";

export const BUNDLE_VERIFICATION_DESK = "verificationDesk";

export const BUNDLE_RESULTS_DECORATION = "resultsDecoration";

export const BUNDLE_ANNOUNCER = "announcer";

export type Bundle = typeof BUNDLE_REFEREE | typeof BUNDLE_VERIFICATION_DESK | typeof BUNDLE_RESULTS_DECORATION | typeof BUNDLE_ANNOUNCER;

export type BundleOption = { key: Bundle; label: string };

// Add a BUNDLE_* constant above and one more entry here as new bundles ship (mirrors the
// per-bundle capability flags in bulmaAdminSidebar.html.twig).
export function bundleOptions(): BundleOption[] {
    return [
        { key: BUNDLE_REFEREE, label: translate("bundle.referee") },
        {
            key: BUNDLE_VERIFICATION_DESK,
            label: translate("bundle.verification_desk"),
        },
        {
            key: BUNDLE_RESULTS_DECORATION,
            label: translate("bundle.results_decoration"),
        },
        { key: BUNDLE_ANNOUNCER, label: translate("bundle.announcer") },
    ];
}

export function bundlesToOptions(bundles: string[]): BundleOption[] {
    return bundleOptions().filter(option => bundles.includes(option.key));
}

export function optionsToBundles(options: BundleOption[]): Bundle[] {
    return options.map(option => option.key);
}

export const TECH_ACCOUNT_MODE_FULL_ACCESS = "fullAccess";
export const TECH_ACCOUNT_MODE_BUNDLED = "bundled";
export type TechAccountMode = typeof TECH_ACCOUNT_MODE_FULL_ACCESS | typeof TECH_ACCOUNT_MODE_BUNDLED;

export const PAYMENT_MANUAL_COMPLETE = "MANUAL_COMPLETE";
export const PAYMENT_STATUS_ONLINE_COMPLETE = "ONLINE_COMPLETE";
export const PAYMENT_STATUS_ONLINE_PROCESSING = "ONLINE_PROCESSING";
export const PAYMENT_STATUS_EXPIRED = "EXPIRED";
export const PAYMENT_STATUS_MISSING = "MISSING";
export const PAYMENT_CONFIRMED_VIA_VOUCHER = "CONFIRMED_VIA_VOUCHER";

export type PaymentStatus =
    | typeof PAYMENT_MANUAL_COMPLETE
    | typeof PAYMENT_STATUS_ONLINE_COMPLETE
    | typeof PAYMENT_STATUS_ONLINE_PROCESSING
    | typeof PAYMENT_STATUS_EXPIRED
    | typeof PAYMENT_STATUS_MISSING
    | typeof PAYMENT_CONFIRMED_VIA_VOUCHER;

//Over time without time limit.
export const TIMER_MODE_STOPWATCH_OVERTIME = "stopwatchOvertime";
export const TIMER_MODE_SECOND_OVERTIME = "secondOvertime";
export const TIMER_MODE_OVERTIME = "overtime";
export const TIMER_MODE_REGULAR_TIME = "regularTime";

export type TimerMode =
    | typeof TIMER_MODE_REGULAR_TIME
    | typeof TIMER_MODE_OVERTIME
    | typeof TIMER_MODE_STOPWATCH_OVERTIME
    | typeof TIMER_MODE_SECOND_OVERTIME;

// Update also EventTypeEnum.
export const EVENT_TYPES = [
    "BJJ Gi",
    "BJJ No-Gi",
    "ADCC",
    "MMA",
    "Submission Only",
    "Combat Ju-Jutsu",
    "Wrestling",
    "Grappling",
    "Aikido",
    "Sambo",
    "Kickboxing",
    "K-1",
    "Judo",
    "Boxing",
    "Muay Thai",
    "Taekwondo",
    "Karate",
    "Ju-Jitsu",
    "Fighting",
    "Ne-waza Gi",
    "Ne-waza No-Gi",
    "Contact Ju-Jitsu",
];

export const STATUS_AWAITING_COMPETITORS = 1;
export const STATUS_FIGHT_IN_PROGRESS = 2;

export const MAX_BRACKET_RANGE = 9999;
